import React from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord, FaFacebook, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-dark-purple-main py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center md:text-left">
          <div>
            <img 
              src={`${process.env.PUBLIC_URL}/resources/images/logo_project.png`} 
              alt="Project San Andreas Roleplay" 
              width="140"
              className="footer-logo mb-4 mx-auto md:mx-0"
            />
            <p className="text-light/80 mb-4 text-justify">
              Tham gia trải nghiệm thế giới Roleplay sống động, công việc phong phú, cộng đồng thân thiện và sự kiện hấp dẫn mỗi tuầnTrải nghiệm thế giới mở sống động, công việc phong phú, cộng đồng thân thiện và sự kiện hấp dẫn mỗi tuần!
            </p>
            <div className="flex space-x-4 justify-center md:justify-start">
              <a href="https://dsc.gg/psa-roleplay" target="_blank" rel="noopener noreferrer" className="text-light/70 hover:text-accent transition-colors">
                <FaDiscord size={24} />
              </a>
              <a href="https://www.facebook.com/psa.roleplay" target="_blank" rel="noopener noreferrer" className="text-light/70 hover:text-accent transition-colors">
                <FaFacebook size={24} />
              </a>
              <a href="https://www.youtube.com/@PSA.Roleplay" target="_blank" rel="noopener noreferrer" className="text-light/70 hover:text-accent transition-colors">
                <FaYoutube size={24} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4 text-accent-teal">Liên Kết</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-light/80 hover:text-accent transition-colors">Trang Chủ</Link></li>
              <li><Link to="/servers" className="text-light/80 hover:text-accent transition-colors">Máy Chủ</Link></li>
              <li><Link to="/download" className="text-light/80 hover:text-accent transition-colors">Tải Về</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4 text-accent-teal">Hỗ Trợ</h3>
            <ul className="space-y-2">
              <li><Link to="/huong-dan" className="text-light/80 hover:text-accent transition-colors">Hướng Dẫn</Link></li>
              <li><Link to="/lien-he" className="text-light/80 hover:text-accent transition-colors">Liên Hệ</Link></li>
              <li><Link to="/faq" className="text-light/80 hover:text-accent transition-colors">FAQ</Link></li>
              <li><Link to="/dieu-khoan" className="text-light/80 hover:text-accent transition-colors">Điều Khoản</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4 text-accent-teal">Liên Hệ</h3>
            <p className="text-light/80 mb-2">Email: psa.roleplay@gmail.com</p>
            <p className="text-light/80 mb-4">Discord: dsc.gg/psa-roleplay</p>
            <a 
              href="https://dsc.gg/psa-roleplay" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-4 py-2 rounded transition-colors"
            >
              <FaDiscord className="mr-2" />
              Tham Gia Discord
            </a>
          </div>
        </div>
        
        <div className="border-t border-white/10 mt-12 pt-8 text-center text-light/60">
          <p>&copy; {new Date().getFullYear()} Project San Andreas Roleplay. All rights reserved.</p>
          <p>GRAND THEFT AUTO IS A REGISTERED TRADEMARK OF TAKE-TWO INTERACTIVE SOFTWARE.</p>
          <p>PROJECT SAN ANDREAS ROLEPLAY IS NOT AFFILIATED WITH OR ENDORSED BY TAKE-TWO INTERACTIVE SOFTWARE AND ITS SUBSIDIARIES © 2007-2022 ALL RIGHTS RESERVED.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
